var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1177_285",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1177_285",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABMElEQVR4nO2aO07DQBRFj5SCsABgMXx2wS4Qn4ouLMKvg22AIkBpgHRA6qSHLizBaKQpkEXzEr+xLd0j3dIeH8/VNG9ADJ9d4AqYA9/AuqV8AW/AJTCOljgAFkAdnE9gP1JkVkCiznmKkjgpKFHnHEWI3HQgMokQqToQqSJErLHIFDhtOdPGGlZCxAa6BhJxYNoRB6qWA1O1HKhaDkzVcqBqOTBVy4Gq5cBULQeqlgNTtRyoWg5M1XKgajkwVcuBquXAVK0t/lYavV23nHkXO1Ii1heRFXCWsxqqyLox0EyD1J8hitz/846HPohUzo9YAqM/z482qFfVl2Hoba5Uyl1fhqHHW5w+m+aQIJ4LSjwSSDqFPgpIvAN7BJMuvFwAr/kiTJuXal6Ac2AnWkIQzC/Vu62CxMnmEgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3779b7ca6bbc19e4922bae9a3a994a71.svg";
export { ForwardRef as ReactComponent };